// @flow

import { observer } from "mobx-react";
import React from "react";

import VideoSearchStore from "app/stores/VideoSearchStore";

import VideoSearch from "app/components/VideoSearch/VideoSearch";

type Props = {
    autoRedirect?: boolean,
    showMessage?: boolean,
    placeholder?: string
};

@observer
export default class VideoSearchContainer extends React.Component<Props> {
    render() {
        const autoRedirect =
            this.props.autoRedirect == null ? true : this.props.autoRedirect;
        const showMessage =
            this.props.showMessage == null ? true : this.props.showMessage;
        const placeholder = this.props.placeholder;

        return (
            <VideoSearch
                onUrl={VideoSearchStore.resolve}
                autoRedirect={autoRedirect}
                showMessage={showMessage}
                placeholder={placeholder}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/containers/VideoSearchContainer.js